import { buildQueryParams, getResData, httpClient } from "utils";


export const SITES_EMISSIONS_API_PATHS = {
  SITES_EMISSIONS: (query: SitesEmissionsQuery) =>
    `/aggregations?${buildQueryParams(query)}`,

  SITES_EMISSIONS_BY_SITE: (query: SitesEmissionsQuery) =>
    `/aggregations/site?${buildQueryParams(query)}`,

  SITES_EMISSIONS_VIEW: (query: SitesEmissionsQuery) =>
    `/aggregations/viewasof?${buildQueryParams(query)}`,

  AUDIT_LOGS: `/audit-log/search`,

  EMISSIONS_EXPORT: (query: SitesEmissionsQuery) =>
    `/aggregations/emissions/export?${buildQueryParams(query)}`,
};

interface UtilityTypeUsage {
  unit: string;
  usage: number;
  utilityType: string;
}

interface SiteAggregation {
  co2Emission: number;
  emissionM2M: number;
  emissionY2Y: number;
  site: string;
  siteId: number;
  utilityTypes: UtilityTypeAggregation[];
  createDate?: any;
}

export interface UtilityTypeAggregation {
  co2Emission: number;
  unit: string;
  usage: number;
  usageM2M: number;
  usageY2Y: number;
  utilityType: string;
  utilityTypeId: number;
}

export interface UtilityModalTypeAggregation {
  accountNumber: number;
  amount: number;
  billGuid: string;
  co2Emission: number;
  currency: string;
  endDate: string;
  id: string;
  measuredUsage: number;
  measuredUsageUnit: string;
  meterNumber: number;
  noOfComments: number;
  period: string;
  providerName: string;
  startDate: string;
  status: string;
  uploader: string;
}

export interface SitesEmissionsDetailsDTO {
  BillDetailsBySiteUtility: UtilityModalTypeAggregation[];
}
export interface SitesEmissionsDTO {
  selectedSites: number;
  siteAggregations: SiteAggregation[] | null;
  totalCo2Emission: number;
  totalCh4OnlyEmission: number;
  totalCo2OnlyEmission: number;
  totalN2oOnlyEmission: number;
  totalScope1Emission: number;
  totalScope2Emission: number;
  totalSites: number;
  totalIntensityProductionCo2Emission: number;
  totalIntensityRevenueCo2Emission: number;
  totalIntensityAreaCo2Emission: number;
  totalMarketIntensityAreaCo2Emission: number;
  totalMarketIntensityProductionCo2Emission: number;
  totalMarketIntensityRevenueCo2Emission: number;
  intensityAreaUnit: string;
  intensityProductionUnit: string;
  intensityRevenueUnit: string;
  utilityTypesUsage: UtilityTypeUsage[];
}

export type SitesEmissionsQuery = {
  endDate: string;
  startDate: string;
  viewType?: string;
  isDisaggregated?: any;
  siteIds?: number[];
  businessUnits?: string[],
  utilityTypeIds?: number[];
  countryRegions?: string[];
};

export type SitesEmissionsQueryview = {
  endDate: string;
  startDate: string;
  viewType?: string;
  isDisaggregated?: any;
  siteIds?: number[];
  utilityTypeIds?: number[];
  viewAsOfDate?: string;
};

export const getSitesEmissions = (
  query: SitesEmissionsQuery,
): Promise<SitesEmissionsDTO> =>
  httpClient
    .get<SitesEmissionsDTO>(SITES_EMISSIONS_API_PATHS.SITES_EMISSIONS(query))
    .then(getResData);

export const getSitesEmissionsBySite = (
  query: SitesEmissionsQuery,
): Promise<SitesEmissionsDTO> =>
  httpClient
    .get<SitesEmissionsDTO>(SITES_EMISSIONS_API_PATHS.SITES_EMISSIONS_BY_SITE(query))
    .then(getResData);

export const getSitesEmissionsview = (
  query: SitesEmissionsQuery,
): Promise<SitesEmissionsDTO> =>
  httpClient
    .get<SitesEmissionsDTO>(SITES_EMISSIONS_API_PATHS.SITES_EMISSIONS_VIEW(query))
    .then(getResData);


export const getAuditLogsData = (
  body: any,
): Promise<any> =>
  httpClient
    .post<any>(SITES_EMISSIONS_API_PATHS.AUDIT_LOGS, body)
    .then(getResData);

export const getEmissionsExport = (
  query: SitesEmissionsQuery,
): Promise<Blob> =>
  httpClient
    .get(SITES_EMISSIONS_API_PATHS.EMISSIONS_EXPORT(query), {
      responseType: 'blob',
    })
    .then((response) => response.data);